import { useState } from "react";
import FormLoading from "../../components/loadding/FormLoading";
// import { useStore } from "../../context/StoreContext";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import bgLogin from "../../images/bg-login.png";
import { useAuthCustomer } from "../../components/hooks/useAuthCustomer"; 

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string>("");
  // const { userId, setUserId } = useStore();
  const { setCustomer } = useAuthCustomer();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);
    setErrorMessage("");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setErrorMessage(data.message);
        return;
      }

      if (res.ok) {
        // localStorage.setItem("authType", "admin");
        setCustomer(data.customer);
        // localStorage.setItem("customer", JSON.stringify(data.customer));

        // setUserId(data.user.id);
        navigate("/");
        
      }

    } catch (error) {
      setErrorMessage("Tài khoản hoặc mật khẩu không chính xác.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="sec-login !h-screen" style={{ backgroundImage: `url(${bgLogin})` }}>
      <div className="container">
        <div className="content rounded-3xl">
          <h2 className="text-center text-[2.8rem] text-[#046DB3] font-bold sm:text-[4rem] -mb-4">Đăng nhập</h2>

          <div className="content-body">
            <form onSubmit={handleSubmit} className="content-form">
              {/* Email */}
              <div className="form-group">
                <input
                  id="email"
                  type="email"
                  className="input"
                  required
                  placeholder="Tài khoản"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {/* <label htmlFor="email" className="label">
                  メールアドレス
                </label> */}
              </div>

              {/* Password */}
              <div className="form-group">
                <input
                  id="password"
                  type="password"
                  className="input"
                  required
                  placeholder="Mật khẩu"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {/* <label htmlFor="password" className="label">
                  パスワード
                </label> */}
              </div>

              {/* Button */}
              <div className="form-btn">
                <button type="submit" className="btn-dark font-semibold">
                  Đăng nhập
                </button>
              </div>
            </form>

            {errorMessage && (
              <p className="mt-6 text-center text-red-600 text-xl">
                {errorMessage}
              </p>
            )}

            <div className="mt-[2.5rem] text-center text-[1.4rem] flex flex-col gap-4 items-center">
              <Link to="/register" className="hover:underline duration-300">Đăng ký</Link>
              <Link to="/reset-password" className="hover:underline duration-300">Quên mật khẩu</Link>
            </div>
          </div>

          {/* <div className="content-ft">
            <p>powered by </p>
          </div> */}
        </div>
      </div>
      {loading && (
        <FormLoading loading={loading} />
      )}
    </section>
  );
};

export default Login;
